import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LOGO_URL = "https://customer-assets.emergentagent.com/job_materiales-pvc-local/artifacts/btr34e4x_WhatsApp%20Image%202026-07-03%20at%208.34.12%20PM.jpeg";
const PHONE_DISPLAY = "+57 322 862 5916";
const PHONE_TEL = "+573228625916";
const ADDRESS = "Carrera 9 #10-65, Barrio Potosí, Fusagasugá";
const WA_BASE_MSG = "Hola PVCenters, quiero cotizar materiales de PVC.";
const WA_URL = `https://wa.me/573228625916?text=${encodeURIComponent(WA_BASE_MSG)}`;
const TEL_URL = `tel:${PHONE_TEL}`;

const PRODUCTS = [
  {
    id: "teja",
    stripes: "stripes-teja",
    title: "Teja de PVC para techo",
    desc: "Lámina termoacústica tipo teja: aísla el calor, reduce el ruido de la lluvia y no requiere mantenimiento. Ideal para viviendas, bodegas y ampliaciones.",
    cta: "Preguntar precio por metro",
    waText: "Hola PVCenters, quisiera cotizar teja de PVC para techo.",
  },
  {
    id: "cielo",
    stripes: "stripes-cielo",
    title: "Cielo raso en PVC",
    desc: "Paneles machihembrados en blanco, madera y colores. Superficie lavable que no se mancha con la humedad ni cría hongos.",
    cta: "Preguntar precio por metro",
    waText: "Hola PVCenters, quisiera cotizar cielo raso en PVC.",
  },
  {
    id: "panel",
    stripes: "stripes-panel",
    title: "Paneles de WPC para pared",
    desc: "Revestimiento decorativo para interiores: cocinas, baños, locales y habitaciones. Se limpia con un paño y transforma el espacio sin obra húmeda.",
    cta: "Ver diseños disponibles",
    waText: "Hola PVCenters, quisiera ver diseños disponibles de paneles de WPC para pared.",
  },
  {
    id: "perfiles",
    stripes: "stripes-perfiles",
    title: "Perfiles y accesorios",
    desc: "Esquineros, rieles, remates, uniones y tornillería para que el trabajo quede bien terminado desde la primera compra.",
    cta: "Consultar disponibilidad",
    waText: "Hola PVCenters, quisiera consultar disponibilidad de perfiles y accesorios de PVC.",
  },
];

const ADVANTAGES = [
  {
    icon: "fa-shield-halved",
    title: "No se oxida ni se daña fácilmente",
    desc: "A diferencia del zinc y la madera, el PVC resiste la lluvia y la humedad constante sin deteriorarse.",
  },
  {
    icon: "fa-feather",
    title: "Liviano y fácil de instalar",
    desc: "Menos peso sobre la estructura y menos tiempo de obra para tu instalador.",
  },
  {
    icon: "fa-soap",
    title: "Lavable y sin mantenimiento",
    desc: "Agua y jabón bastan. Sin pintura, sin impermeabilizante, sin gastos cada año.",
  },
  {
    icon: "fa-temperature-low",
    title: "Térmico y acústico",
    desc: "Mantiene los espacios más frescos y amortigua el golpeteo de la lluvia en el techo.",
  },
];

const COVERAGE = [
  { name: "Fusagasugá", primary: true },
  { name: "Chinauta" },
  { name: "Silvania" },
  { name: "Tibacuy" },
  { name: "Pasca" },
  { name: "Arbeláez" },
  { name: "San Bernardo" },
  { name: "Pandi" },
  { name: "Venecia" },
  { name: "Cabrera" },
  { name: "Granada" },
  { name: "Sibaté" },
  { name: "Melgar" },
  { name: "Icononzo" },
  { name: "Boquerón" },
];

const STEPS = [
  {
    n: "01",
    title: "Cuéntanos tus medidas",
    desc: "Escríbenos el área a cubrir (largo × ancho) por WhatsApp o llamada. Si no las tienes exactas, te orientamos.",
  },
  {
    n: "02",
    title: "Recibe tu cotización",
    desc: "Te decimos cuántas láminas o paneles necesitas, con perfiles y accesorios incluidos, y el valor total.",
  },
  {
    n: "03",
    title: "Recoge tu material",
    desc: "Pagas y recoges tu pedido en nuestro punto en Fusagasugá, listo para que tu instalador haga el resto.",
  },
];

function waLink(text) {
  return `https://wa.me/573228625916?text=${encodeURIComponent(text)}`;
}

export default function Landing() {
  const [form, setForm] = useState({
    nombre: "",
    telefono: "",
    producto: "",
    detalles: "",
  });

  // Reviews state
  const [reviews, setReviews] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(true);
  const [reviewForm, setReviewForm] = useState({
    nombre: "",
    municipio: "",
    calificacion: 5,
    comentario: "",
  });
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  const [reviewStatus, setReviewStatus] = useState(null); // { type: 'ok'|'err', msg }

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/reviews`);
        if (!cancelled) setReviews(res.data || []);
      } catch (e) {
        if (!cancelled) setReviews([]);
      } finally {
        if (!cancelled) setReviewsLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const onReviewChange = (e) => setReviewForm({ ...reviewForm, [e.target.name]: e.target.value });

  const onReviewSubmit = async (e) => {
    e.preventDefault();
    setReviewSubmitting(true);
    setReviewStatus(null);
    try {
      const payload = {
        nombre: reviewForm.nombre.trim(),
        municipio: reviewForm.municipio.trim(),
        calificacion: Number(reviewForm.calificacion),
        comentario: reviewForm.comentario.trim(),
      };
      const res = await axios.post(`${API}/reviews`, payload);
      setReviews([res.data, ...reviews]);
      setReviewForm({ nombre: "", municipio: "", calificacion: 5, comentario: "" });
      setReviewStatus({ type: "ok", msg: "¡Gracias! Tu reseña se publicó." });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = Array.isArray(detail) ? detail.map(d => d.msg).join(" · ") : (detail || "No pudimos publicar tu reseña. Intenta de nuevo.");
      setReviewStatus({ type: "err", msg });
    } finally {
      setReviewSubmitting(false);
    }
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    const producto = form.producto || "Sin especificar";
    const msg = `Hola PVCenters, quiero una cotización:\n• Nombre: ${form.nombre || "-"}\n• Teléfono: ${form.telefono || "-"}\n• Producto: ${producto}\n• Detalles: ${form.detalles || "-"}`;
    const url = `https://wa.me/573228625916?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="landing-root" className="font-body text-[color:var(--pvc-charcoal)]">
      {/* Top strip */}
      <div data-testid="top-strip" className="bg-[color:var(--pvc-navy-deep)] text-white text-xs sm:text-sm">
        <div className="container-pvc flex flex-col md:flex-row items-center justify-between gap-1 py-2">
          <div className="tracking-wide text-center md:text-left">
            <i className="fa-solid fa-location-dot mr-2 text-[color:var(--pvc-red)]" aria-hidden="true"></i>
            <span>Carrera 9 #10-65, Barrio Potosí, Fusagasugá</span>
            <span className="mx-2 text-white/40">·</span>
            <span>Lun–Vie 8 a. m.–6 p. m. · Sáb 8 a. m.–3 p. m.</span>
          </div>
          <a
            data-testid="top-phone-link"
            href={TEL_URL}
            className="font-display-700 tracking-widest text-white hover:text-[color:var(--pvc-silver)] transition-colors"
          >
            <i className="fa-solid fa-phone mr-2" aria-hidden="true"></i>
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>

      {/* Sticky header */}
      <header
        data-testid="site-header"
        className="sticky top-0 z-50 bg-white border-b-[4px] border-[color:var(--pvc-red)] shadow-sm"
      >
        <div className="container-pvc flex items-center justify-between py-3">
          <a href="#top" onClick={scrollTo("top")} data-testid="header-logo-link" className="flex items-center">
            <img
              src={LOGO_URL}
              alt="PVCenters — Materiales para techos y paredes"
              className="h-[80px] md:h-[110px] w-auto object-contain"
              loading="eager"
            />
          </a>

          <nav data-testid="main-nav" className="hidden md:flex items-center gap-7">
            <a href="#productos" onClick={scrollTo("productos")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Productos</a>
            <a href="#ventajas" onClick={scrollTo("ventajas")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Ventajas</a>
            <a href="#cobertura" onClick={scrollTo("cobertura")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Cobertura</a>
            <a href="#como-comprar" onClick={scrollTo("como-comprar")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Cómo comprar</a>
            <a href="#resenas" onClick={scrollTo("resenas")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Reseñas</a>
            <a href="#contacto" onClick={scrollTo("contacto")} className="font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)] hover:text-[color:var(--pvc-red)] transition-colors">Contacto</a>
          </nav>

          <a
            data-testid="header-cta-cotizar"
            href="#contacto"
            onClick={scrollTo("contacto")}
            className="btn-primary text-sm px-4 py-2.5 md:px-5 md:py-3"
          >
            Cotizar ahora
          </a>
        </div>
      </header>

      {/* HERO */}
      <section id="top" data-testid="hero" className="pvc-corrugated-hero text-white relative overflow-hidden">
        <div className="container-pvc py-20 md:py-28 lg:py-32 relative">
          <div className="max-w-3xl">
            <div className="flex flex-wrap items-center gap-2 fade-up">
              <span data-testid="hero-pill" className="pill">
                <span className="w-2 h-2 rounded-full bg-[color:var(--pvc-red)] mr-2 inline-block"></span>
                Venta directa en Fusagasugá
              </span>
              <span data-testid="hero-pill-importadores" className="pill" style={{ background: "var(--pvc-red)", borderColor: "var(--pvc-red)" }}>
                <i className="fa-solid fa-ship mr-2" aria-hidden="true"></i>
                Importadores directos
              </span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl mt-6 fade-up-2"
            >
              Techos y paredes en <span className="headline-red">PVC</span> que resisten el clima de la región
            </h1>

            <p data-testid="hero-subtitle" className="mt-6 text-base sm:text-lg text-[color:var(--pvc-silver)] leading-relaxed max-w-2xl fade-up-3">
              Láminas, cielo rasos y paneles de PVC listos para instalar: livianos, lavables y que no se oxidan ni se dañan fácilmente con la humedad del Sumapaz. Compra directo, sin intermediarios.
            </p>

            <div data-testid="hero-ctas" className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 fade-up-4">
              <a
                data-testid="hero-cta-whatsapp"
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary btn-whatsapp"
              >
                <i className="fa-brands fa-whatsapp text-xl" aria-hidden="true"></i>
                Cotizar por WhatsApp
              </a>
              <a
                data-testid="hero-cta-call"
                href={TEL_URL}
                className="btn-ghost"
              >
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
                Llamar ahora
              </a>
            </div>

            <p data-testid="hero-note" className="mt-6 text-xs sm:text-sm text-[color:var(--pvc-silver)]/85 max-w-xl fade-up-4">
              Somos punto de venta de materiales. La instalación la realiza tu maestro de obra o instalador de confianza.
            </p>
          </div>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* PRODUCTOS */}
      <section id="productos" data-testid="section-productos" className="section bg-[color:var(--pvc-smoke)]">
        <div className="container-pvc">
          <div className="max-w-2xl">
            <span className="kicker">Lo que vendemos</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[color:var(--pvc-navy-deep)]">
              Materiales en <span className="headline-red">PVC</span> para cada superficie
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
            {PRODUCTS.map((p) => (
              <article
                key={p.id}
                data-testid={`product-card-${p.id}`}
                className="card-product"
              >
                <div className={`h-24 ${p.stripes}`} aria-hidden="true"></div>
                <div className="p-6 flex flex-col grow">
                  <h3 className="font-display text-xl sm:text-2xl text-[color:var(--pvc-navy-deep)] leading-tight">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[color:var(--pvc-charcoal)] grow">
                    {p.desc}
                  </p>
                  <a
                    data-testid={`product-link-${p.id}`}
                    href={waLink(p.waText)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex items-center gap-2 font-display-700 text-sm tracking-widest text-[color:var(--pvc-red)] hover:text-[color:var(--pvc-red-dark)] transition-colors"
                  >
                    {p.cta} <span aria-hidden="true">→</span>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* VENTAJAS */}
      <section id="ventajas" data-testid="section-ventajas" className="section bg-[color:var(--pvc-navy)] text-white">
        <div className="container-pvc">
          <div className="max-w-2xl">
            <span className="kicker">Por qué PVC</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl">
              Hecho para el clima del <span className="headline-red">Sumapaz</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
            {ADVANTAGES.map((a, i) => (
              <div key={i} data-testid={`advantage-${i}`} className="card-adv">
                <div className="w-12 h-12 rounded-md bg-[color:var(--pvc-red)] flex items-center justify-center mb-4">
                  <i className={`fa-solid ${a.icon} text-white text-lg`} aria-hidden="true"></i>
                </div>
                <h3 className="font-display text-xl sm:text-2xl leading-tight">{a.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--pvc-silver)]">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* COBERTURA */}
      <section id="cobertura" data-testid="section-cobertura" className="section bg-white">
        <div className="container-pvc">
          <div className="max-w-3xl">
            <span className="kicker">Zona de cobertura</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[color:var(--pvc-navy-deep)]">
              Atendemos Fusagasugá y toda la región del <span className="headline-red">Sumapaz</span>
            </h2>
            <p className="mt-5 text-base text-[color:var(--pvc-charcoal)] leading-relaxed">
              Ven por tu material a nuestro punto de venta en Fusagasugá. Recibimos clientes y maestros de obra de:
            </p>
          </div>

          <div data-testid="coverage-list" className="mt-8 flex flex-wrap gap-3">
            {COVERAGE.map((c) => (
              <span
                key={c.name}
                data-testid={`coverage-chip-${c.name.toLowerCase().replace(/[^a-z]/g, "")}`}
                className={`chip ${c.primary ? "chip-primary" : ""}`}
              >
                {c.primary && <i className="fa-solid fa-location-dot mr-2" aria-hidden="true"></i>}
                {c.name}
              </span>
            ))}
          </div>

          <p className="mt-8 text-sm sm:text-base text-[color:var(--pvc-charcoal)] max-w-3xl">
            ¿Vienes de otro municipio? <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="text-[color:var(--pvc-red)] font-semibold hover:underline">Escríbenos antes por WhatsApp</a> y dejamos tu pedido listo para que solo pases a recogerlo.
          </p>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* CÓMO COMPRAR */}
      <section id="como-comprar" data-testid="section-como-comprar" className="section bg-[color:var(--pvc-smoke)]">
        <div className="container-pvc">
          <div className="max-w-2xl">
            <span className="kicker">Proceso de compra</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[color:var(--pvc-navy-deep)]">
              Comprar es así de <span className="headline-red">simple</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10">
            {STEPS.map((s) => (
              <div key={s.n} data-testid={`step-${s.n}`} className="step-card">
                <div className="step-number">{s.n}</div>
                <div className="w-12 h-1 bg-[color:var(--pvc-red)] mt-2 mb-5"></div>
                <h3 className="font-display text-xl sm:text-2xl text-[color:var(--pvc-navy-deep)]">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--pvc-charcoal)]">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* RESEÑAS */}
      <section id="resenas" data-testid="section-resenas" className="section bg-white">
        <div className="container-pvc">
          <div className="max-w-2xl">
            <span className="kicker">Opiniones</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[color:var(--pvc-navy-deep)]">
              Lo que dicen nuestros <span className="headline-red">clientes</span>
            </h2>
            <p className="mt-5 text-base text-[color:var(--pvc-charcoal)] leading-relaxed">
              Comparte tu experiencia comprando con nosotros. Tu comentario ayuda a otros clientes del Sumapaz a decidir.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
            {/* Left: form (spans 1 col) */}
            <form
              data-testid="review-form"
              onSubmit={onReviewSubmit}
              className="lg:col-span-1 bg-[color:var(--pvc-smoke)] border border-[#E4E7EC] rounded-md p-6 self-start"
            >
              <h3 className="font-display text-2xl text-[color:var(--pvc-navy-deep)]">Deja tu reseña</h3>

              <div className="mt-5">
                <label className="form-label" htmlFor="review-nombre">Nombre</label>
                <input
                  data-testid="review-nombre"
                  id="review-nombre"
                  name="nombre"
                  type="text"
                  required
                  minLength={2}
                  maxLength={60}
                  value={reviewForm.nombre}
                  onChange={onReviewChange}
                  className="form-input"
                  placeholder="Tu nombre"
                />
              </div>

              <div className="mt-4">
                <label className="form-label" htmlFor="review-municipio">Municipio (opcional)</label>
                <input
                  data-testid="review-municipio"
                  id="review-municipio"
                  name="municipio"
                  type="text"
                  maxLength={60}
                  value={reviewForm.municipio}
                  onChange={onReviewChange}
                  className="form-input"
                  placeholder="Ej: Fusagasugá, Chinauta…"
                />
              </div>

              <div className="mt-4">
                <label className="form-label">Calificación</label>
                <div data-testid="review-stars" className="flex items-center gap-2">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <button
                      key={n}
                      type="button"
                      data-testid={`review-star-${n}`}
                      onClick={() => setReviewForm({ ...reviewForm, calificacion: n })}
                      aria-label={`${n} estrellas`}
                      className="text-2xl transition-transform hover:scale-110"
                      style={{ color: n <= reviewForm.calificacion ? "var(--pvc-red)" : "#C6CBD2" }}
                    >
                      <i className="fa-solid fa-star" aria-hidden="true"></i>
                    </button>
                  ))}
                  <span className="ml-2 font-display-700 text-sm tracking-widest text-[color:var(--pvc-navy-deep)]">
                    {reviewForm.calificacion}/5
                  </span>
                </div>
              </div>

              <div className="mt-4">
                <label className="form-label" htmlFor="review-comentario">Tu comentario</label>
                <textarea
                  data-testid="review-comentario"
                  id="review-comentario"
                  name="comentario"
                  required
                  minLength={5}
                  maxLength={500}
                  value={reviewForm.comentario}
                  onChange={onReviewChange}
                  className="form-textarea"
                  placeholder="Cuéntanos cómo fue tu experiencia con PVCenters."
                />
              </div>

              <button
                data-testid="review-submit"
                type="submit"
                className="btn-primary mt-5 w-full"
                disabled={reviewSubmitting}
                style={reviewSubmitting ? { opacity: 0.6, cursor: "not-allowed" } : {}}
              >
                {reviewSubmitting ? "Publicando…" : "Publicar reseña"}
              </button>

              {reviewStatus && (
                <p
                  data-testid="review-status"
                  className="mt-3 text-sm"
                  style={{ color: reviewStatus.type === "ok" ? "var(--pvc-whatsapp-dark)" : "var(--pvc-red-dark)" }}
                >
                  {reviewStatus.msg}
                </p>
              )}
            </form>

            {/* Right: reviews list (spans 2 cols) */}
            <div className="lg:col-span-2">
              {reviewsLoading ? (
                <div data-testid="reviews-loading" className="text-sm text-[color:var(--pvc-charcoal)] py-10 text-center">
                  Cargando reseñas…
                </div>
              ) : reviews.length === 0 ? (
                <div
                  data-testid="reviews-empty"
                  className="border border-dashed border-[#C6CBD2] rounded-md p-8 text-center bg-[color:var(--pvc-smoke)]"
                >
                  <i className="fa-regular fa-comment text-3xl text-[color:var(--pvc-red)] mb-3 block" aria-hidden="true"></i>
                  <h3 className="font-display text-2xl text-[color:var(--pvc-navy-deep)]">Sé el primero en opinar</h3>
                  <p className="mt-2 text-sm text-[color:var(--pvc-charcoal)]">
                    Aún no hay reseñas publicadas. Cuéntanos tu experiencia comprando con PVCenters.
                  </p>
                </div>
              ) : (
                <div data-testid="reviews-list" className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {reviews.map((r) => (
                    <article
                      key={r.id}
                      data-testid={`review-item-${r.id}`}
                      className="bg-white border border-[#E4E7EC] rounded-md p-5 hover:shadow-lg hover:border-[color:var(--pvc-red)] transition-all"
                    >
                      <div className="flex items-center gap-1 text-[color:var(--pvc-red)] text-sm mb-3">
                        {[1, 2, 3, 4, 5].map((n) => (
                          <i
                            key={n}
                            className="fa-solid fa-star"
                            style={{ color: n <= (r.calificacion || 5) ? "var(--pvc-red)" : "#E4E7EC" }}
                            aria-hidden="true"
                          ></i>
                        ))}
                      </div>
                      <p className="text-sm leading-relaxed text-[color:var(--pvc-charcoal)] whitespace-pre-wrap">
                        “{r.comentario}”
                      </p>
                      <div className="mt-4 pt-3 border-t border-[#E4E7EC]">
                        <p className="font-display-700 text-sm tracking-wide text-[color:var(--pvc-navy-deep)]">{r.nombre}</p>
                        {r.municipio && (
                          <p className="text-xs text-[color:var(--pvc-charcoal)]/80">
                            <i className="fa-solid fa-location-dot mr-1 text-[color:var(--pvc-red)]" aria-hidden="true"></i>
                            {r.municipio}
                          </p>
                        )}
                      </div>
                    </article>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="pvc-divider" aria-hidden="true"></div>

      {/* CONTACTO */}
      <section id="contacto" data-testid="section-contacto" className="section bg-white">
        <div className="container-pvc">
          <div className="max-w-2xl">
            <span className="kicker">Contacto</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[color:var(--pvc-navy-deep)]">
              Cotiza <span className="headline-red">hoy mismo</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-10">
            {/* Left: contact cards */}
            <div className="space-y-4">
              <a data-testid="contact-card-call" href={TEL_URL} className="contact-card group">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-md bg-[color:var(--pvc-red)] flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-phone text-white text-lg" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 className="font-display text-xl text-[color:var(--pvc-navy-deep)]">Llámanos</h3>
                    <p className="mt-1 font-display-700 tracking-wider text-[color:var(--pvc-red)] text-lg">{PHONE_DISPLAY}</p>
                    <p className="mt-1 text-sm text-[color:var(--pvc-charcoal)]">Lun–Vie 8 a. m.–6 p. m. · Sáb 8 a. m.–3 p. m.</p>
                  </div>
                </div>
              </a>

              <a data-testid="contact-card-whatsapp" href={WA_URL} target="_blank" rel="noopener noreferrer" className="contact-card group">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-md bg-[color:var(--pvc-whatsapp)] flex items-center justify-center shrink-0">
                    <i className="fa-brands fa-whatsapp text-white text-xl" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 className="font-display text-xl text-[color:var(--pvc-navy-deep)]">WhatsApp</h3>
                    <p className="mt-1 font-display-700 tracking-wider text-[color:var(--pvc-whatsapp-dark)] text-lg">{PHONE_DISPLAY}</p>
                    <p className="mt-1 text-sm text-[color:var(--pvc-charcoal)]">Envía tus medidas y te cotizamos.</p>
                  </div>
                </div>
              </a>

              <div className="contact-card" style={{ cursor: "default" }}>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-md bg-[color:var(--pvc-navy)] flex items-center justify-center shrink-0">
                    <i className="fa-solid fa-location-dot text-white text-lg" aria-hidden="true"></i>
                  </div>
                  <div>
                    <h3 className="font-display text-xl text-[color:var(--pvc-navy-deep)]">Punto de venta</h3>
                    <p className="mt-1 font-display-700 tracking-wide text-[color:var(--pvc-navy)] text-base">Carrera 9 #10-65</p>
                    <p className="text-sm text-[color:var(--pvc-charcoal)]">Barrio Potosí · Fusagasugá, Cundinamarca</p>
                    <a
                      data-testid="address-maps-link"
                      href="https://www.google.com/maps/search/?api=1&query=Carrera+9+%2310-65+Barrio+Potos%C3%AD+Fusagasug%C3%A1"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-2 inline-flex items-center gap-2 font-display-700 text-xs tracking-widest text-[color:var(--pvc-red)] hover:text-[color:var(--pvc-red-dark)]"
                    >
                      Cómo llegar <span aria-hidden="true">→</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: form */}
            <form
              data-testid="quote-form"
              onSubmit={onSubmit}
              className="bg-[color:var(--pvc-smoke)] border border-[#E4E7EC] rounded-md p-6 md:p-8"
            >
              <h3 className="font-display text-2xl text-[color:var(--pvc-navy-deep)]">Solicita tu cotización</h3>
              <p className="mt-1 text-sm text-[color:var(--pvc-charcoal)]">
                Al enviar, se abrirá WhatsApp con tu cotización lista para enviarnos.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="form-label" htmlFor="nombre">Nombre</label>
                  <input
                    data-testid="form-nombre"
                    id="nombre"
                    name="nombre"
                    type="text"
                    required
                    value={form.nombre}
                    onChange={onChange}
                    className="form-input"
                    placeholder="Tu nombre"
                  />
                </div>
                <div>
                  <label className="form-label" htmlFor="telefono">Teléfono / WhatsApp</label>
                  <input
                    data-testid="form-telefono"
                    id="telefono"
                    name="telefono"
                    type="tel"
                    required
                    value={form.telefono}
                    onChange={onChange}
                    className="form-input"
                    placeholder="Ej: 3001234567"
                  />
                </div>
              </div>

              <div className="mt-4">
                <label className="form-label" htmlFor="producto">Producto de interés</label>
                <select
                  data-testid="form-producto"
                  id="producto"
                  name="producto"
                  required
                  value={form.producto}
                  onChange={onChange}
                  className="form-select"
                >
                  <option value="">Selecciona un producto</option>
                  <option value="Teja de PVC para techo">Teja de PVC para techo</option>
                  <option value="Cielo raso en PVC">Cielo raso en PVC</option>
                  <option value="Paneles de WPC para pared">Paneles de WPC para pared</option>
                  <option value="Perfiles y accesorios">Perfiles y accesorios</option>
                  <option value="Varios productos">Varios productos</option>
                </select>
              </div>

              <div className="mt-4">
                <label className="form-label" htmlFor="detalles">Medidas o detalles del proyecto</label>
                <textarea
                  data-testid="form-detalles"
                  id="detalles"
                  name="detalles"
                  value={form.detalles}
                  onChange={onChange}
                  className="form-textarea"
                  placeholder="Ej: Necesito techar 20 m² (5 × 4), casa en Chinauta."
                />
              </div>

              <button data-testid="form-submit" type="submit" className="btn-primary btn-whatsapp mt-6 w-full">
                <i className="fa-brands fa-whatsapp text-xl" aria-hidden="true"></i>
                Enviar cotización por WhatsApp
              </button>

              <p className="mt-4 text-xs text-[color:var(--pvc-charcoal)]/80">
                Solo usamos tus datos para responder tu cotización.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer data-testid="site-footer" className="bg-[color:var(--pvc-navy-deep)] text-white pt-14 pb-6">
        <div className="container-pvc">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <img
                src={LOGO_URL}
                alt="PVCenters"
                className="h-16 w-auto object-contain bg-white p-2 rounded-md"
                loading="lazy"
              />
              <p className="mt-4 text-sm text-[color:var(--pvc-silver)] leading-relaxed">
                Punto de venta de materiales en PVC para techos, cielo rasos y paredes en Fusagasugá.
                Atendemos Chinauta, Silvania, Tibacuy, Pasca, Arbeláez, San Bernardo, Pandi, Venecia, Cabrera, Granada, Sibaté, Melgar, Icononzo, Boquerón y toda la región del Sumapaz.
              </p>
            </div>

            <div>
              <h4 className="font-display text-lg tracking-widest">Menú</h4>
              <div className="w-10 h-0.5 bg-[color:var(--pvc-red)] mt-2 mb-4"></div>
              <ul className="space-y-2 text-sm">
                <li><a href="#productos" onClick={scrollTo("productos")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Productos</a></li>
                <li><a href="#ventajas" onClick={scrollTo("ventajas")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Ventajas</a></li>
                <li><a href="#cobertura" onClick={scrollTo("cobertura")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Cobertura</a></li>
                <li><a href="#como-comprar" onClick={scrollTo("como-comprar")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Cómo comprar</a></li>
                <li><a href="#resenas" onClick={scrollTo("resenas")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Reseñas</a></li>
                <li><a href="#contacto" onClick={scrollTo("contacto")} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors">Contacto</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-display text-lg tracking-widest">Contacto</h4>
              <div className="w-10 h-0.5 bg-[color:var(--pvc-red)] mt-2 mb-4"></div>
              <ul className="space-y-3 text-sm">
                <li>
                  <a data-testid="footer-phone" href={TEL_URL} className="text-[color:var(--pvc-silver)] hover:text-white transition-colors inline-flex items-center gap-2">
                    <i className="fa-solid fa-phone text-[color:var(--pvc-red)]" aria-hidden="true"></i>
                    {PHONE_DISPLAY}
                  </a>
                </li>
                <li>
                  <a data-testid="footer-whatsapp" href={WA_URL} target="_blank" rel="noopener noreferrer" className="text-[color:var(--pvc-silver)] hover:text-white transition-colors inline-flex items-center gap-2">
                    <i className="fa-brands fa-whatsapp text-[color:var(--pvc-whatsapp)]" aria-hidden="true"></i>
                    WhatsApp
                  </a>
                </li>
                <li className="text-[color:var(--pvc-silver)] inline-flex items-start gap-2">
                  <i className="fa-solid fa-location-dot text-[color:var(--pvc-red)] mt-1" aria-hidden="true"></i>
                  <span>Carrera 9 #10-65, Barrio Potosí<br/>Fusagasugá, Cundinamarca, Colombia</span>
                </li>
                <li className="text-[color:var(--pvc-silver)] inline-flex items-center gap-2">
                  <i className="fa-regular fa-clock text-[color:var(--pvc-red)]" aria-hidden="true"></i>
                  Lun–Vie 8 a. m.–6 p. m. · Sáb 8 a. m.–3 p. m.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-white/10 text-center text-xs text-[color:var(--pvc-silver)]">
            © 2026 PVCenters · Materiales para techos y paredes · Fusagasugá, Colombia
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp */}
      <a
        data-testid="wa-float"
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-float"
        aria-label="Escríbenos por WhatsApp"
      >
        <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
      </a>
    </div>
  );
}
